/**
 * CDN Origin Error Logs
 *
 * Contact: daniel@bunny.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { HttpClient, HttpContext, HttpEvent, HttpParams, HttpResponse } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';

import { Observable } from 'rxjs';

// @ts-ignore
import { BaseService } from '../api.base.service';
import { Configuration } from '../configuration';
import { ErrorCode } from '../model/error-code';
// @ts-ignore
import { HttpMethod } from '../model/http-method';
// @ts-ignore
import { OriginLogsList } from '../model/origin-logs-list';
// @ts-ignore
import { StatusCode } from '../model/status-code';
// @ts-ignore
import { BASE_PATH } from '../variables';

export interface GetPullzoneOriginErrorLogsRequestParams {
  /** ID of Pull Zone that needs to be fetched. */
  pullzoneId: number;
  /** Date of format YYYY-MM-DD */
  date: string;
  /** Next page token. */
  continuationToken?: string;
  /** Previous page token. */
  startToken?: string;
  /** Per page. */
  logsToReturn?: number;
  /** Country code. */
  country?: string;
  /** Server Id. */
  serverId?: string;
  /** Request method. */
  httpMethod?: HttpMethod;
  /** Error code(s). */
  errorCode?: ErrorCode[];
  /** Status code(s). */
  statusCode?: StatusCode[];
  /** Status code. */
  serverZone?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ErrorLogsService extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration?: Configuration,
  ) {
    super(basePath, configuration);
  }

  /**
   * Pull zone origin Error logs.
   * Returns a list of origin Error logs.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPullzoneOriginErrorLogs(
    requestParameters: GetPullzoneOriginErrorLogsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<OriginLogsList>;
  public getPullzoneOriginErrorLogs(
    requestParameters: GetPullzoneOriginErrorLogsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<OriginLogsList>>;
  public getPullzoneOriginErrorLogs(
    requestParameters: GetPullzoneOriginErrorLogsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<OriginLogsList>>;
  public getPullzoneOriginErrorLogs(
    requestParameters: GetPullzoneOriginErrorLogsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const pullzoneId = requestParameters?.pullzoneId;
    if (pullzoneId === null || pullzoneId === undefined) {
      throw new Error('Required parameter pullzoneId was null or undefined when calling getPullzoneOriginErrorLogs.');
    }
    const date = requestParameters?.date;
    if (date === null || date === undefined) {
      throw new Error('Required parameter date was null or undefined when calling getPullzoneOriginErrorLogs.');
    }
    const continuationToken = requestParameters?.continuationToken;
    const startToken = requestParameters?.startToken;
    const logsToReturn = requestParameters?.logsToReturn;
    const country = requestParameters?.country;
    const serverId = requestParameters?.serverId;
    const httpMethod = requestParameters?.httpMethod;
    const errorCode = requestParameters?.errorCode;
    const statusCode = requestParameters?.statusCode;
    const serverZone = requestParameters?.serverZone;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>continuationToken, 'continuationToken');
    localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startToken, 'startToken');
    localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>logsToReturn, 'logsToReturn');
    localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>country, 'Country');
    localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>serverId, 'ServerId');
    localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>httpMethod, 'HttpMethod');
    if (errorCode) {
      errorCode.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ErrorCode');
      });
    }
    if (statusCode) {
      statusCode.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'StatusCode');
      });
    }
    localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>serverZone, 'ServerZone');

    let localVarHeaders = this.defaultHeaders;

    // authentication (AdminApiAuth) required
    localVarHeaders = this.configuration.addCredentialToHeaders('AdminApiAuth', 'AdminToken', localVarHeaders);

    // authentication (UserApiJWTAuth) required
    localVarHeaders = this.configuration.addCredentialToHeaders('UserApiJWTAuth', 'authorization', localVarHeaders);

    // authentication (UserApiKey) required
    localVarHeaders = this.configuration.addCredentialToHeaders('UserApiKey', 'AccessKey', localVarHeaders);

    const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/${this.configuration.encodeParam({ name: 'pullzoneId', value: pullzoneId, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int64' })}/${this.configuration.encodeParam({ name: 'date', value: date, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'date' })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<OriginLogsList>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }
}
